export default __webpack_public_path__ + "static/media/n4.e3aecbbe.jpeg";